/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Linkrequiredtitle3Inputs */

const en_signin_linkrequiredtitle3 = /** @type {(inputs: Signin_Linkrequiredtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in link required`)
};

const fr_signin_linkrequiredtitle3 = /** @type {(inputs: Signin_Linkrequiredtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien de connexion requis`)
};

/**
* | output |
* | --- |
* | "Sign-in link required" |
*
* @param {Signin_Linkrequiredtitle3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_linkrequiredtitle3 = /** @type {((inputs?: Signin_Linkrequiredtitle3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Linkrequiredtitle3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_linkrequiredtitle3(inputs)
	return fr_signin_linkrequiredtitle3(inputs)
});
export { signin_linkrequiredtitle3 as "signIn_linkRequiredTitle" }